import * as placeTokens from '../constants/PlaceTokens';
import * as views from '../constants/ViewMode'
import * as CapabilityType from '../constants/CapabilityType'
import {userCan} from "../login/Security";
import {getMenuLineBySrc, isEntityEnabled} from "../login/ClientCache";
import * as ts from "../common/Translator";
import {translateId} from "../common/Translator";
import {constructNama} from "../common/Metadata";
import * as BSEntities from "../constants/BSEntities";
import * as ConstantViewNames from "../constants/ConstantViewNames";
import {isNullOrUndefined} from "../common/NamaCommon";

export class NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        if (!src && parentPlace) {
            src = parentPlace.src;
        }
        let that = this;
        that.params = parseTokens(tokens);
        if (!that.params.get(placeTokens.PRM_MENU_HASH) && src)
            that.params.set(placeTokens.PRM_MENU_HASH, src);
    }

    windowTitle() {

    }

    get src() {
        return this.params.get(placeTokens.PRM_MENU_HASH);
    }

    set src(src) {
        this.params.set(placeTokens.PRM_MENU_HASH, src);
    }

    get fields() {
        return this.params.get(placeTokens.PRM_FIELDS);
    }

    set fields(fields) {
        this.params.set(placeTokens.PRM_FIELDS, fields);
    }

    doGet(paramName) {
        return this.params.get(paramName);
    }

    doGetBoolean(paramName) {
        if (!this.doGet(paramName))
            return false;
        return this.doGet(paramName).toString().toLowerCase() === 'true';
    }

    doSet(paramName, val) {
        this.params.set(paramName, val);
    }

    tokenize() {
        let keyValuePairs = [...this.params];
        window.xx = this;
        if (!keyValuePairs || !keyValuePairs.length)
            return "";

        return keyValuePairs.map(([key, value]) => {
            if (value)
                return key + placeTokens.PAIR_SEPERATOR + value;
            return "";
        }).join(placeTokens.PARAMETERS_SEPERATOR);
    }

    fullLink() {
        return "#" + this.prefix() + ":" + this.tokenize();
    }

    prefix() {
        return "";
    }

    /**
     *
     * @return {{entityType: string, capabilities: string[]}}
     */
    getRequiredSecurityCapabilities() {
        return {entityType: "", capabilities: []}
    }

    isAllowedInCurrentSecurityProfile() {
        let place = this;
        let requiredSecurityCapabilities = place.getRequiredSecurityCapabilities();
        if (!requiredSecurityCapabilities.entityType)
            return true;
        if (!isEntityEnabled(requiredSecurityCapabilities.entityType)) {
            return false;
        }
        for (let capability of requiredSecurityCapabilities.capabilities) {
            if (!userCan(requiredSecurityCapabilities.entityType, capability)) {
                return false;
            }
        }
        return true;
    }
}
export class WelcomePlace extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace});
    }

    windowTitle() {
        return translateId("homePage");
    }

    get showIds() {
        return this.doGetBoolean(placeTokens.PRM_SHOW_IDS);
    }

    set showIds(val) {
        return this.doSet(placeTokens.PRM_SHOW_IDS, val);
    }

    get replicateOptions() {
        return this.doGetBoolean(placeTokens.PRM_REPLICATION_OPTIONS);
    }

    set replicateOptions(val) {
        return this.doSet(placeTokens.PRM_REPLICATION_OPTIONS, val);
    }

    get debugDirtyCheck() {
        return this.doGetBoolean(placeTokens.PRM_DEBUG);
    }

    set debugDirtyCheck(val) {
        return this.doSet(placeTokens.PRM_DEBUG, val);
    }

    get dashBoardId() {
        return this.doGet(placeTokens.PRM_DASHBOARDID);
    }

    set dashBoardId(val) {
        return this.doSet(placeTokens.PRM_DASHBOARDID, val);
    }

    get serverCreatedObjectId() {
        return this.doGet(placeTokens.PRM_SERVEROBJECT);
    }

    set serverCreatedObjectId(val) {
        return this.doSet(placeTokens.PRM_SERVEROBJECT, val);
    }

    get importObjects() {
        return this.doGet(placeTokens.PRM_IMPORT_OBJECTS);
    }

    set importObjects(val) {
        return this.doSet(placeTokens.PRM_IMPORT_OBJECTS, val);
    }

    get nestActive() {
        return this.doGet(placeTokens.PRM_NESTING);
    }

    set nestActive(val) {
        return this.doSet(placeTokens.PRM_NESTING, val);
    }

    get flowId() {
        return this.doGet(placeTokens.PRM_FLOW_ID);
    }

    set flowId(val) {
        return this.doSet(placeTokens.PRM_FLOW_ID, val);
    }

    get flowTargetType() {
        return this.doGet(placeTokens.PRM_FLOW_TARGET_TYPE);
    }

    set flowTargetType(val) {
        return this.doSet(placeTokens.PRM_FLOW_TARGET_TYPE, val);
    }

    get flowTargetId() {
        return this.doGet(placeTokens.PRM_FLOW_TARGET_ID);
    }

    set flowTargetId(val) {
        return this.doSet(placeTokens.PRM_FLOW_TARGET_ID, val);
    }
}

export class EntityListPlace extends NamaPlace {
    constructor({tokens, src, parentPlace, copyFromPlace, currentEntityType} = {}) {
        super({tokens, src, parentPlace})
        let that = this;
        if (copyFromPlace) {
            for (let [key, value] of parentPlace.params) {
                if (key === placeTokens.PRM_ID || key === placeTokens.PRM_EDIT_TEMPLATE_ID)
                    continue;
                if (key === placeTokens.PRM_LIST_VIEW_NAME && currentEntityType && currentEntityType !== parentPlace.entityType)
                    continue;
                that.params.set(key, value);
            }
        }
    }

    windowTitle() {
        let that = this;
        let entityType = that.entityType;
        if (!entityType)
            return "";
        let layout = that.preferences ? that.preferences.listLayout : null;
        let menuLine = getMenuLineBySrc(that.src);
        return ts.getListViewTitle(entityType, that.listViewName, layout, menuLine);
    }

    create({tokens, src, parentPlace} = {}) {
        return new EntityListPlace({tokens, src, parentPlace});
    }

    get entityType() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    set entityType(val) {
        this.doSet(placeTokens.PRM_ENTITY_TYPE, val);
    }

    get currentPage() {
        return this.doGet(placeTokens.PRM_PAGE);
    }

    set currentPage(val) {
        return this.doSet(placeTokens.PRM_PAGE, val);
    }

    get pageSize() {
        return this.doGet(placeTokens.PRM_PAGE_SIZE);
    }

    set pageSize(val) {
        return this.doSet(placeTokens.PRM_PAGE_SIZE, val);
    }

    get listViewName() {
        return this.doGet(placeTokens.PRM_LIST_VIEW_NAME);
    }

    set listViewName(val) {
        return this.doSet(placeTokens.PRM_LIST_VIEW_NAME, val)
    }

    get criteria() {
        return this.doGet(placeTokens.PRM_CRITERIA);
    }

    set criteria(value) {
        return this.doSet(placeTokens.PRM_CRITERIA, value);
    }

    get questions() {
        return this.doGet(placeTokens.PRM_QUESTIONS);
    }

    set questions(val) {
        return this.doSet(placeTokens.PRM_QUESTIONS, val);
    }

    get ascending() {
        let asc = this.doGet(placeTokens.PRM_ASCENDING);
        if (isNullOrUndefined(asc))
            return true;
        return asc.toLowerCase() === "true";
    }

    set ascending(val) {
        return this.doSet(placeTokens.PRM_ASCENDING, val + "");
    }

    get sortBy() {
        return this.doGet(placeTokens.PRM_SORT_BY);
    }

    set sortBy(val) {
        return this.doSet(placeTokens.PRM_SORT_BY, val);
    }

    get showTree() {
        return this.doGet(placeTokens.PRM_SHOW_TREE);
    }

    set showTree(val) {
        return this.doSet(placeTokens.PRM_SHOW_TREE, val);
    }

    get extraCriteria() {
        return this.doGet(placeTokens.PRM_EXTRA_CRITERIA);
    }

    set extraCriteria(value) {
        return this.doSet(placeTokens.PRM_EXTRA_CRITERIA, value);
    }

    prefix() {
        return placeTokens.PREFIX_LIST;
    }

    getRequiredSecurityCapabilities() {
        return {entityType: this.entityType, capabilities: [CapabilityType.ListView]}
    }
}

export class SQLPlace extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return "Run SQL Statements";
    }

    create({tokens, src, parentPlace} = {}) {
        return new SQLPlace({tokens, src, parentPlace});
    }

    getRequiredSecurityCapabilities() {
        return {entityType: "User", capabilities: [CapabilityType.EditAfterCommit, CapabilityType.Delete]}
    }

    prefix() {
        return placeTokens.PREFIX_sql;
    }
}

export class FieldsSelectorPlace extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return "Select Fields";
    }

    create({tokens, src, parentPlace} = {}) {
        return new FieldsSelectorPlace({tokens, src, parentPlace});
    }

    prefix() {
        return placeTokens.FIELDS_SELECTOR_POPUP;
    }

    get entityType() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    set entityType(val) {
        this.doSet(placeTokens.PRM_ENTITY_TYPE, val);
    }

    get pendingResponseId() {
        return this.doGet(placeTokens.PRM_PENDING_RESPONSE_ID)
    }
    get dataSource1() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_1)
    }
    get dataSource2() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_2)
    }
    get dataSource3() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_3)
    }
    get dataSource4() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_4)
    }
    get dataSource5() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_5)
    }

    get isFromReportingEntity() {
        return this.doGet(placeTokens.PRM_IS_FROM_REPORTING_ENTITY)
    }

    set pendingResponseId(pendingResponseId) {
        return this.doSet(placeTokens.PRM_PENDING_RESPONSE_ID, pendingResponseId)
    }
}

export class ReportPlace extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace});
    }

    windowTitle() {
        return translateId("reports");
    }

    get questions() {
        return this.doGet(placeTokens.PRM_QUESTIONS);
    }

    set questions(val) {
        return this.doSet(placeTokens.PRM_QUESTIONS, val);
    }

    get tempPrintId() {
        return this.doGet(placeTokens.PRM_TEMP_PRINT_ID);
    }

    set tempPrintId(val) {
        return this.doSet(placeTokens.PRM_TEMP_PRINT_ID, val);
    }

    get reportId() {
        return this.doGet(placeTokens.PRM_ID);
    }

    set reportId(val) {
        return this.doSet(placeTokens.PRM_ID, val);
    }

    get printingOption() {
        return this.doGet(placeTokens.PRM_PRINTING_OPTION);
    }

    set printingOption(val) {
        return this.doSet(placeTokens.PRM_PRINTING_OPTION, val);
    }

    get purpose() {
        return this.doGet(placeTokens.PRM_DOWNLOAD_PURPOSE);
    }

    set purpose(val) {
        return this.doSet(placeTokens.PRM_DOWNLOAD_PURPOSE, val);
    }

    get format() {
        return this.doGet(placeTokens.PRM_OUTPUT_FORMAT);
    }

    set format(val) {
        return this.doSet(placeTokens.PRM_OUTPUT_FORMAT, val);
    }


}

export class ReportViewerPlace extends ReportPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    prefix() {
        return placeTokens.PREFIX_REPORT_Result;
    }

    set embeddedReportView(embeddedView){
        this.embeddedView = embeddedView;
    }

    get embeddedReportView(){
        return this.embeddedView;
    }

    set embeddedViewContainer(viewContainer){
        this.viewContainer = viewContainer;
    }

    get embeddedViewContainer(){
        return this.viewContainer;
    }
}

export class LoginPlace extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return translateId("login");
    }

    prefix() {
        return placeTokens.PREFIX_login;
    }

    get resetToken() {
        return this.doGet(placeTokens.PRM_RESET_TOKEN);
    }

    set resetToken(value) {
        return this.doSet(placeTokens.PRM_RESET_TOKEN, value);
    }

    get resetUserId() {
        return this.doGet(placeTokens.PRM_RESET_USER);
    }

    set resetUserId(value) {
        return this.doSet(placeTokens.PRM_RESET_USER, value);
    }

    get previousPlace() {
        return this.prevPlace;
    }

    set previousPlace(value) {
        return this.prevPlace = value;
    }

    isAllowedInCurrentSecurityProfile() {
        return true;
    }
}

export class ReportLauncherPlace extends ReportPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    prefix() {
        return placeTokens.PREFIX_LAUNCH_REPORT;
    }
}

export class ListReportPlace extends EntityListPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace});
        this.showTree = true;
        this.entityType = BSEntities.ReportDefinition;
        this.listViewName = ConstantViewNames.REPORT_CATALOGUE_SCREEN_NAME
    }

    get currentRoot() {
        return this.doGet(placeTokens.PRM_ROOT);
    }

    set currentRoot(value) {
        return this.doSet(placeTokens.PRM_ROOT, value);
    }

    get rootType() {
        return this.doGet(placeTokens.PRM_ROOT_TYPE);
    }

    set rootType(value) {
        return this.doSet(placeTokens.PRM_ROOT_TYPE, value);
    }

    prefix() {
        return placeTokens.PREFIX_REPORT_List;
    }
}
export class EditPlace extends EntityListPlace {
    constructor({tokens, src, parentPlace, copyFromPlace, currentEntityType} = {}) {
        super({tokens, src, parentPlace, copyFromPlace, currentEntityType})
    }

    calcEditViewName() {
        return this.editViewName || this.listViewName;
    }
    windowTitle() {
        let that = this;
        let line = getMenuLineBySrc(that.src);
        if (line != null && line.target.targetEntity === that.entityType && (line.editViewArTitle || line.editViewEnTitle))
            return ts.getName(line.editViewArTitle, line.editViewEnTitle);
        return ts.translateId(that.entityType);
    }

    prefix() {
        return placeTokens.PREFIX_EDIT;
    }

    get id() {
        return this.doGet(placeTokens.PRM_ID);
    }

    set id(value) {
        return this.doSet(placeTokens.PRM_ID, value);
    }

    get view() {
        return this.doGet(placeTokens.PRM_VIEW);
    }

    set view(value) {
        return this.doSet(placeTokens.PRM_VIEW, value);
    }

    get editViewName() {
        return this.doGet(placeTokens.PRM_EDIT_VIEW_NAME);
    }

    set editViewName(value) {
        return this.doSet(placeTokens.PRM_EDIT_VIEW_NAME, value);
    }

    get pageId() {
        return this.doGet(placeTokens.PRM_PAGE_ID);
    }

    set pageId(value) {
        return this.doSet(placeTokens.PRM_PAGE_ID, value);
    }

    get quickCreate() {
        return this.doGet(placeTokens.PRM_QUICKCREATE);
    }

    set quickCreate(value) {
        return this.doSet(placeTokens.PRM_QUICKCREATE, value);
    }

    get quickCreateRequester() {
        return this.doGet(placeTokens.PRM_QUICKCREATE_REQUESTER);
    }

    set quickCreateRequester(value) {
        return this.doSet(placeTokens.PRM_QUICKCREATE_REQUESTER, value);
    }

    get version() {
        return this.doGet(placeTokens.PRM_VERSION);
    }

    set version(value) {
        return this.doSet(placeTokens.PRM_VERSION, value);
    }

    get templateId() {
        return this.doGet(placeTokens.PRM_EDIT_TEMPLATE_ID);
    }

    set templateId(value) {
        return this.doSet(placeTokens.PRM_EDIT_TEMPLATE_ID, value);
    }

    get createdObject() {
        return this._createdObject;
    }

    set createdObject(o) {
        this._createdObject = o;
    }

    get focusOnField() {
        return this.doGet(placeTokens.PRM_FOCUS_ON_FIELD);
    }

    set focusOnField(value) {
        return this.doSet(placeTokens.PRM_FOCUS_ON_FIELD, value);
    }

    getRequiredSecurityCapabilities() {
        return {entityType: this.entityType, capabilities: [CapabilityType.RecordView]}
    }
}

export class WizardPlace extends NamaPlace {
    windowTitle() {
        return translateId("wizard");
    }

    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    prefix() {
        return placeTokens.WIZARD_VIEW;
    }
}

export class LayoutEditorPlace extends NamaPlace {
    windowTitle() {
        return translateId(placeTokens.LAYOUT_EDITOR_VIEW);
    }

    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    prefix() {
        return placeTokens.LAYOUT_EDITOR_VIEW;
    }

    get entityType() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    calcEditViewName() {
        return this.editViewName || this.listViewName;
    }

    set entityType(val) {
        this.doSet(placeTokens.PRM_ENTITY_TYPE, val);
    }

    get editViewName() {
        return this.doGet(placeTokens.PRM_EDIT_VIEW_NAME);
    }

    set editViewName(value) {
        return this.doSet(placeTokens.PRM_EDIT_VIEW_NAME, value);
    }

    get id() {
        return this.doGet(placeTokens.PRM_ID)
    }

    set id(val) {
        return this.doSet(placeTokens.PRM_ID, val)
    }

    get isQuickCreatorView(){
        return this.doGet(placeTokens.PRM_FOR_QUICK_CREATOR_VIEW)
    }

    get isMobileView(){
        return this.doGet(placeTokens.PRM_FOR_MOBILE_VIEW)
    }
}

export class ReportWizardEditor extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return "Report Wizard Editor";
    }

    prefix() {
        return placeTokens.REPORT_WIZARD_EDITOR;
    }

    get reportWizardId() {
        return this.doGet(placeTokens.PRM_REPORT_WIZARD_ID)
    }

    set reportWizardId(val) {
        return this.doSet(placeTokens.PRM_REPORT_WIZARD_ID, val)
    }

    get entityType() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    set entityType(val) {
        this.doSet(placeTokens.PRM_ENTITY_TYPE, val);
    }
}

export class ReportExpressionEditor extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return "Report Expression Editor";
    }

    prefix() {
        return placeTokens.REPORT_EXPRESSION_EDITOR;
    }

    get pendingResponseId() {
        return this.doGet(placeTokens.PRM_PENDING_RESPONSE_ID)
    }

    get screenType() {
        return this.doGet(placeTokens.PRM_SCREEN_TYPE)
    }

    get dataSource1() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_1)
    }

    get dataSource2() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_2)
    }

    get dataSource3() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_3)
    }

    get dataSource4() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_4)
    }

    get dataSource5() {
        return this.doGet(placeTokens.PRM_DATA_SOURCE_5)
    }

    get entityType() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    get fieldTitle() {
        return this.doGet(placeTokens.PRM_FIELD_TITLE)
    }
}

export class ReportUnionHandlingEditor extends NamaPlace {
    constructor({tokens, src, parentPlace} = {}) {
        super({tokens, src, parentPlace})
    }

    windowTitle() {
        return "Report Union Handling Editor";
    }

    prefix() {
        return placeTokens.REPORT_UNION_HANDLING_EDITOR;
    }

    get pendingResponseId() {
        return this.doGet(placeTokens.PRM_PENDING_RESPONSE_ID)
    }

    get mainTable() {
        return this.doGet(placeTokens.PRM_ENTITY_TYPE)
    }

    get fieldTitle() {
        return this.doGet(placeTokens.PRM_FIELD_TITLE)
    }
}

function parseTokens(token) {
    let values = new Map();
    if (!token)
        return values;
    token += placeTokens.PARAMETERS_SEPERATOR;
    let keyValuePairs = token.split(placeTokens.PARAMETERS_SEPERATOR);
    for (let keyValuePair of keyValuePairs) {
        let parts = keyValuePair.split(placeTokens.PAIR_SEPERATOR);
        if (parts.length !== 2) // ignore any malformed parameters
            continue;
        let key = parts[0];
        let value = "";
        if (parts.length > 1)
            value = parts[1];
        values.set(key, value);
    }
    return values;
}

export function linkToRef(ref) {
    if (!ref || !ref.entityType)
        return "";
    let place = editPlace(ref.entityType, ref.id);
    return place.fullLink();
}

export function editPlace(entityType, id) {
    let editPlace = new EditPlace();
    editPlace.entityType = entityType;
    editPlace.view = views.EDIT;
    editPlace.id = id;
    return editPlace;
}